<template>
  <div :class="['data-grid-cascader', condition, {'use-condition': !disableComplex}]">
    <div v-if="!disableComplex && conditionTypes && conditionTypes.length"
         class="condition">
      <el-dropdown placement="bottom-start"
                   @command="cascaderCondition">
        <div class="el-dropdown-icon theme-text-active theme-light-bg-active"
             :class="{'is-active': hasCondition}">
          <div v-if="conditionType"
               class="wrapper"
               :class="{'is-word': conditionType.word}">
            {{conditionType.char}}
          </div>
          <div v-else
               class="wrapper">
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown"
                          class="data-grid-cascader-condition-menu">
          <el-dropdown-item command=""
                            :class="{'theme-text theme-light-bg': !hasCondition}">
            <div class="condition-box">
              <div class="icon">
                <div class="wrapper">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <div class="text">条目筛选</div>
            </div>
          </el-dropdown-item>
          <el-dropdown-item v-for="(conditionType, index) in conditionTypes"
                            :key="'condition_' + index"
                            :command="conditionType.name"
                            :class="{'theme-text theme-light-bg': conditionType.name === condition}">
            <div class="condition-box">
              <div class="icon">
                <div class="wrapper"
                     :class="{'is-word': conditionType.word}">
                  {{conditionType.char}}
                </div>
              </div>
              <div class="text">{{conditionType.text}}</div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="handler">
      <DataGridSearchCascader :disabled="hasCondition"
                              v-bind="$attrs"
                              v-on="$listeners"
                              style="width: 100%"></DataGridSearchCascader>
    </div>
  </div>
</template>

<script>
import DataGridSearchCascader from './DataGridSearchCascader'
import conditionEnum from '../../../constants/conditionEnum'
export default {
  name: 'DataGridCascader',
  components: {
    DataGridSearchCascader
  },
  props: {
    condition: {
      type: String,
      default: ''
    },
    disableComplex: {
      type: Boolean
    }
  },
  data () {
    return {
      conditionTypes: [
        conditionEnum.NULL,
        conditionEnum.NOT_NULL
      ]
    }
  },
  computed: {
    conditionType () {
      let conditionTypes = this.conditionTypes
      if (conditionTypes && conditionTypes.length) {
        let conditionType = conditionTypes.find(conditionType => conditionType.name === this.condition)
        if (conditionType) {
          return conditionType
        }
      }
    },
    hasCondition () {
      return !!this.conditionType
    }
  },
  methods: {
    cascaderCondition (command) {
      this.$emit('update:condition', command)
    }
  }
}
</script>

<style lang="scss">
  @use "../../../styles/common" as *;
  .data-grid-cascader {
    position: relative;
    &>.condition {
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9;
      display: flex;
      align-items: center;
      .wrapper {
        cursor: pointer;
      }
    }
    &.use-condition {
      &>.handler {
        .el-cascader {
          .el-cascader__tags {
            margin-left: 24px;
            .el-cascader__search-input {
              margin-left: 6px;
            }
          }
          .el-input {
            .el-input__inner {
              padding-left: 30px;
            }
          }
        }
      }
    }
  }
  .data-grid-cascader-condition-menu {
    min-width: 180px;
    margin-left: -7px;
    .condition-box {
      display: flex;
      align-items: center;
      font-size: 12px;
      .text {
        margin-left: 6px;
        padding: 1px 4px;
      }
    }
  }
  .data-grid-cascader .el-dropdown-icon,
  .data-grid-cascader-condition-menu .condition-box .icon {
    position: relative;
    width: 16px;
    height: 16px;
    font-size: 12px;
    background: #f7f8f9;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,.08);
    box-sizing: border-box;
    &>.wrapper {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%) scale(.72);
      white-space: nowrap;
      &:not(.is-word) {
        transform: translate(-50%,-50%) scale(.9);
        @extend .console-font;
      }
      i {
        margin: auto!important;
      }
    }
  }
</style>
